import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="mt-24 lg:mt-32 pt-12 border-t border-[#1B6B3A]/20 pb-12" data-id="element-44">
      <p className="text-xs text-[#6B6B6B]/70 text-center mb-6 leading-loose max-w-lg mx-auto text-balance" data-id="element-45">
        This product is for informational and educational purposes only. It does
        not constitute legal advice or financial advice. Results may vary
        depending on your specific transaction. Consult a licensed attorney or
        financial advisor for decisions related to your home purchase. By
        purchasing, you agree to our Terms of Service and Privacy Policy.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#6B6B6B]" data-id="element-46">
        <p data-id="element-47">
          © {new Date().getFullYear()} Closing Number Lock. All rights
          reserved.
        </p>
        <div className="flex items-center gap-6" data-id="element-48">
          <Link to="/terms" className="hover:text-[#1B6B3A] transition-colors duration-200 underline underline-offset-2 decoration-[#6B6B6B]/30 hover:decoration-[#1B6B3A]" data-id="element-49">
            Terms of Service
          </Link>
          <Link to="/privacy" className="hover:text-[#1B6B3A] transition-colors duration-200 underline underline-offset-2 decoration-[#6B6B6B]/30 hover:decoration-[#1B6B3A]" data-id="element-50">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>;
}